import moment from 'moment';

export const dateFormat = dateISOString => {
  return moment(dateISOString).format('DD/MM/YY, HH:mm:ss');
};

export const dateFormat24hr = dateISOString => {
  return moment(dateISOString).format('DD MMM YYYY, HH:mm:ss');
};

export const formatPerformanceRangeFrom = dateStr => {
  if (!dateStr) {
    return '';
  }

  return moment(dateStr, 'YYYY-MM-DD')
    .startOf('day')
    .format('DD MMM YYYY, HH:mm:ss');
};

export const formatPerformanceRangeTo = (toDate, updatedAt) => {
  if (!toDate) {
    return '';
  }

  if (updatedAt) {
    const updatedAtDay = String(updatedAt).split('T')[0];
    if (updatedAtDay && toDate === updatedAtDay) {
      return moment(updatedAt).format('DD MMM YYYY, HH:mm:ss');
    }
  }

  return moment(toDate, 'YYYY-MM-DD')
    .endOf('day')
    .format('DD MMM YYYY, HH:mm:ss');
};

export const dateFormatLocal = dateISOString => {
  return moment(dateISOString).format('LLL');
};

export const dateOnlyFormat = dateISOString => {
  return moment(dateISOString).format('DD/MM/YY');
};
export const monthOnlyFormat = dateISOString => {
  return moment(dateISOString).format('MMM YY');
};

export const dateISOFormat = dateString => {
  return moment(dateString, 'DD/MM/YY').toISOString();
};

export const toEpochTimestamp = dateString => {
  return moment(dateString, 'DD/MM/YY, HH:mm:ss').unix();
};

export const getFromDate = toDate => {
  let fromDate = moment(toDate).subtract(1, 'days').startOf('day');
  return fromDate.format('YYYY-MM-DD');
};

export const getMinDate = (createdAt, updatedAt) => {
  const createdAtTimestamp = moment(createdAt);
  const updatedAtTimestamp = moment(updatedAt);

  if (updatedAtTimestamp.diff(createdAtTimestamp, 'days') > 30) {
    return updatedAtTimestamp.subtract(1, 'months').toISOString(true);
  } else {
    return createdAtTimestamp.toISOString(true);
  }
};

export const getDiffInDays = (fromDate, toDate, quantity) => {
  const from = moment(fromDate);
  const to = moment(toDate);
  if (to.diff(from, 'days') > quantity) {
    return false;
  } else {
    return true;
  }
};

export const getISTDayUtcRange = (fromDate, toDate) => {
  const from =
    new Date(`${fromDate}T00:00:01+05:30`).toISOString().split('.')[0] + 'Z';

  const toDateObj = new Date(`${toDate}T23:59:59+05:30`);
  const to = toDateObj.toISOString().split('.')[0] + 'Z';

  return { from, to };
};

export const getEcotronGraphUtcRange = (fromDate, toDate) => {
  const from =
    new Date(`${fromDate}T00:00:01+05:30`).toISOString().split('.')[0] + 'Z';

  const to =
    new Date(`${toDate}T23:59:59+05:30`).toISOString().split('.')[0] + 'Z';

  return { from, to };
};

export const getV3GraphRange = (fromDate, toDate) => {
  const from =
    new Date(`${fromDate}T00:00:01+05:30`).toISOString().split('.')[0] + 'Z';

  const toDateObj = new Date(`${toDate}T23:59:59+05:30`);
  toDateObj.setSeconds(toDateObj.getSeconds() - 3);

  const to = toDateObj.toISOString().split('.')[0] + 'Z';

  return { from, to };
};
